var React = require("react"),
  ReactDOM = require("react-dom");

Array.prototype.sortByKey = function(key) {
  var array = this;

  return array.sort(function(a, b) {
    var arrayKey = key.split(".");
    var _a = a,
      _b = b;
    var length = arrayKey.length;
    for (var i = 0; i < length; i++) {
      if (_a) {
        _a = _a[arrayKey[i]];
      }
      if (_b) {
        _b = _b[arrayKey[i]];
      }
    }
    if (!_a) {
      return -1;
    }
    if (!_b) {
      return 1;
    }
    return _a > _b ? 1 : _b > _a ? -1 : 0;
  });
};

Array.prototype.mapWithRow = function(method, numberElementPerRow, _classNameRow) {
  var array = this;

  var arrayPerPair = [];
  var length = array.length;
  for (var i = 0; i < length; i = i + numberElementPerRow) {
    var _a = [];
    var j = Math.min(i + numberElementPerRow, length);
    var i2 = i;
    while (i2 < j) {
      _a.push(array[i2]);
      i2 = i2 + 1;
    }
    arrayPerPair.push(_a);
  }

  return arrayPerPair.map(function(els, index) {
    var classNameRow = "row";
    if (_classNameRow) {
      classNameRow += " " + _classNameRow;
    }
    return (
      <div className={classNameRow} key={"row_" + index}>
        {els.map(method)}
      </div>
    );
  });
};

String.prototype.addS = function(_a) {
  var a = parseInt(_a, 10);
  if (isNaN(a)) {
    return this;
  }
  return this + (a > 1 ? "s" : "");
};

String.prototype.firstLetterToCapital = function() {
  return this.trim()
    .replace(/ +/g, " ")
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      if (word && word.length > 0) {
        return word[0].toUpperCase() + word.substr(1);
      } else {
        return "";
      }
    })
    .join(" ");
};

Array.prototype.cleanArrayInt = function() {
  var _array = [],
    element;
  var length = this.length;
  for (var i = 0; i < length; i++) {
    element = parseInt(this[i]);
    if (!isNaN(element)) {
      _array.push(element);
    }
  }

  return _array;
};



// WEBPACK FOOTER //
// ./assets/react/utils/prototypes.js